import { checkStockMap, checkBondMap } from './fieldConfig/checkReleased';
import { stockMap, bondMap } from './fieldConfig/common';
import { plateStockMap } from './fieldConfig/newThreePlate';

// new_plate 为新三板
const fieldStockMap: any = {
  today_order: stockMap,
  today_success: checkStockMap,
  wait_order: stockMap,
  new_plate: plateStockMap,
}

// new_plate 为新三板
const fieldBondMap: any = {
  today_order: bondMap,
  today_success: checkBondMap,
  wait_order: bondMap,
  new_plate: [],
}

/**
 * @param { string } type 模块类型
 * @returns {} 模块字段配置
 */
const getStockMapData = (type: string) => {
  return fieldStockMap[type];
}

/**
 * @param { string } type 模块类型
 * @returns {} 模块字段配置
 */
const getBondMapData = (type: string) => {
  return fieldBondMap[type];
}

/**
 * @param { } item 接口返回数据
 * @param { } isBond 是否是可转债数据
 * @returns {} 符合渲染规范的股票基本信息
 */
const getCodeMessage = (item: any, index: number, isBond?: boolean) => {
  return {
    name: isBond ? item.bond_name : item.stock_name, // 股票名称
    exchange: isBond ? 'BOND' : item.exchange, // 股票市场
    code: isBond ? item.bond_code : item.stock_code, // 股票代码
    orderDate: item.order_date, // 申购日期
    successDate: item.success_date, // 中签日期
    orderCode: item.order_code, // 申购代码
    marketId: item.market_id,
    break_probability: item.break_probability,
    pe_static_ratio: item.pe_static_ratio,
    pe_ttm_ratio: item.pe_ttm_ratio,
    net_profit_growth_rate_ratio: item.net_profit_growth_rate_ratio,
    industry_ttm: item.industry_ttm,
    net_profit_growth_rate: item.net_profit_growth_rate,
    issue_pe_ttm: item.issue_pe_ttm,
    issue_pe_static: item.issue_pe_static,
    index
  }
}

/**
 * @param { } item 接口返回数据
 * @param { } itemMap 配置的需要获取的字段配置
 * @returns {} 符合渲染规范的股票基本信息
 */
function getStockListData(item: any, itemMap: any) {
  const listData = itemMap;
  let itemList: any[] = [];
  const resData: any[] = [];
  listData.forEach((it: any, index: number) => {
    // 如果配置的字段没有值则不展示
    if (it.show && !it.show(item[it.field])) {
      return;
    }
    // 一一对应接口数据获取需要的字段数据(如果有配置format，则使用format格式化)
    const objVal: any = {
      ...it,
      value: it.format ? it.format(item[it.field]) : item[it.field]
    }
    itemList.push(objVal);
    // 两两一组放入数组中方便后续组件渲染数据为二维数组，采用一维数组渲不利于使用table标签
    if (index % 2 !== 0 || (index === listData.length - 1 && index % 2 === 0)) {
      resData.push(itemList);
      itemList = [];
    }
  });
  return resData;
}


/**
 * @param { } data 接口返回数据
 * @param { } stockMap 股票/债券模块字段配置
 * @param { } isBond 是否是可转债数据
 * @returns {} stockCard组件可以使用的数据结构
 */
const getStockData = (data: any, stockMap: any, isBond?: boolean) => {
  // 数据不存在返回空数组
  if (!data || data.length === 0) {
    return [];
  }
  const resData: any[] = [];
  data.forEach((item: any, index: number) => {
    // 股票基本信息 名称代码等
    const codeMessage = getCodeMessage(item, index, isBond)
    // 股票基础数据信息
    const dataList = getStockListData(item, stockMap);
    resData.push(
      {
        ...codeMessage,
        dataList,
      }
    )
  })
  return resData;
}


/**
 * @param { } data 接口返回数据
 * @param { } stockMap 股票模块字段配置
 * @param { } bondMap 可转债模块字段配置
 * @returns {} stockCard组件可以使用的数据结构
 */
const getData = (data: any, stockMap: any, bondMap: any) => {
  // 将转债数据正序排列
  const dataBond = data && data.bond ? data.bond.reverse() : [];
  return {
    stock: getStockData(data && data.stock, stockMap), // 新股数据
    bond: getStockData(dataBond, bondMap, true), // 新债数据
  }
}

/**
 * @param { } data 接口返回数据
 * @param { string } type 模块类型
 * @returns {} stockCard组件可以使用的数据结构
 */
export function handleStockData(data: any, type: string) {
  // 获取新股申购需要展示的后端字段
  const fieldStockMap = getStockMapData(type);
  // 获取新债申购需要展示的后端字段
  const fieldBondMap = getBondMapData(type);
  // 获取符合列表展示的处理后的数据结构
  const resData = getData(data, fieldStockMap, fieldBondMap);
  return resData;
}